import { render } from "./ModifierParc.vue?vue&type=template&id=88c36f30"
import script from "./ModifierParc.vue?vue&type=script&lang=js"
export * from "./ModifierParc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__